import { render } from "./IconArrowUp.vue?vue&type=template&id=32375c6a"
import script from "./IconArrowUp.vue?vue&type=script&lang=js"
export * from "./IconArrowUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__